export interface FirebaseCourseData {
  name?: string;
  field?: FirebaseField;
  instructorIds: string[];
  archived: boolean;
  frozen: boolean;
  description?: string;
  prereqNotes?: string;
  zoomLink?: string;
  courseLevel?: FirebaseCourseLevel;
  studentCountInfo?: FirebaseStudentCountInfo;
  gradeInfo?: FirebaseGradeInfo;
  sections?: FirebaseSectionInfo[];
  curriculumFiles?: FirebaseFileInfo[];
}

export enum FirebaseField {
  CompSciEng,
  Humanities,
  SciMath,
  Lifestyle,
  Arts,
  WorldLang,
}

export enum FirebaseCourseLevel {
  OneHundred = 100,
  TwoHundred = 200,
}

export interface FirebaseStudentCountInfo {
  recommended: number;
  max: number;
}

export interface FirebaseGradeInfo {
  regular: FirebaseGradeRange;
  exception: FirebaseGradeRange;
}

export interface FirebaseGradeRange {
  min: number;
  max: number;
}

export interface FirebaseSectionInfo {
  meetings: FirebaseMeeting[];
  timeZone: FirebaseTimeZone; // minutesFromWeekStart for each meeting is in this time zone
}

// Supported time zones (we should hypothetically support all time zones but this subset is sufficient)
// Key and value for easy mapping
export enum FirebaseTimeZone {
  'Etc/GMT+12' = 'Etc/GMT+12',
  'Pacific/Midway' = 'Pacific/Midway',
  'Pacific/Honolulu' = 'Pacific/Honolulu',
  'US/Alaska' = 'US/Alaska',
  'America/Los_Angeles' = 'America/Los_Angeles',
  'America/Tijuana' = 'America/Tijuana',
  'US/Arizona' = 'US/Arizona',
  'America/Chihuahua' = 'America/Chihuahua',
  'US/Mountain' = 'US/Mountain',
  'America/Managua' = 'America/Managua',
  'US/Central' = 'US/Central',
  'America/Mexico_City' = 'America/Mexico_City',
  'Canada/Saskatchewan' = 'Canada/Saskatchewan',
  'America/Bogota' = 'America/Bogota',
  'US/Eastern' = 'US/Eastern',
  'US/East-Indiana' = 'US/East-Indiana',
  'Canada/Atlantic' = 'Canada/Atlantic',
  'America/Caracas' = 'America/Caracas',
  'America/Manaus' = 'America/Manaus',
  'America/Santiago' = 'America/Santiago',
  'Canada/Newfoundland' = 'Canada/Newfoundland',
  'America/Sao_Paulo' = 'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires' = 'America/Argentina/Buenos_Aires',
  'America/Godthab' = 'America/Godthab',
  'America/Montevideo' = 'America/Montevideo',
  'America/Noronha' = 'America/Noronha',
  'Atlantic/Cape_Verde' = 'Atlantic/Cape_Verde',
  'Atlantic/Azores' = 'Atlantic/Azores',
  'Africa/Casablanca' = 'Africa/Casablanca',
  'Etc/Greenwich' = 'Etc/Greenwich',
  'Europe/Amsterdam' = 'Europe/Amsterdam',
  'Europe/Belgrade' = 'Europe/Belgrade',
  'Europe/Brussels' = 'Europe/Brussels',
  'Europe/Sarajevo' = 'Europe/Sarajevo',
  'Africa/Lagos' = 'Africa/Lagos',
  'Asia/Amman' = 'Asia/Amman',
  'Europe/Athens' = 'Europe/Athens',
  'Asia/Beirut' = 'Asia/Beirut',
  'Africa/Cairo' = 'Africa/Cairo',
  'Africa/Harare' = 'Africa/Harare',
  'Europe/Helsinki' = 'Europe/Helsinki',
  'Asia/Jerusalem' = 'Asia/Jerusalem',
  'Europe/Minsk' = 'Europe/Minsk',
  'Africa/Windhoek' = 'Africa/Windhoek',
  'Asia/Kuwait' = 'Asia/Kuwait',
  'Europe/Moscow' = 'Europe/Moscow',
  'Africa/Nairobi' = 'Africa/Nairobi',
  'Asia/Tbilisi' = 'Asia/Tbilisi',
  'Asia/Tehran' = 'Asia/Tehran',
  'Asia/Muscat' = 'Asia/Muscat',
  'Asia/Baku' = 'Asia/Baku',
  'Asia/Yerevan' = 'Asia/Yerevan',
  'Asia/Kabul' = 'Asia/Kabul',
  'Asia/Yekaterinburg' = 'Asia/Yekaterinburg',
  'Asia/Karachi' = 'Asia/Karachi',
  'Asia/Calcutta' = 'Asia/Calcutta',
  'Asia/Katmandu' = 'Asia/Katmandu',
  'Asia/Almaty' = 'Asia/Almaty',
  'Asia/Dhaka' = 'Asia/Dhaka',
  'Asia/Rangoon' = 'Asia/Rangoon',
  'Asia/Bangkok' = 'Asia/Bangkok',
  'Asia/Krasnoyarsk' = 'Asia/Krasnoyarsk',
  'Asia/Hong_Kong' = 'Asia/Hong_Kong',
  'Asia/Kuala_Lumpur' = 'Asia/Kuala_Lumpur',
  'Asia/Irkutsk' = 'Asia/Irkutsk',
  'Australia/Perth' = 'Australia/Perth',
  'Asia/Taipei' = 'Asia/Taipei',
  'Asia/Tokyo' = 'Asia/Tokyo',
  'Asia/Seoul' = 'Asia/Seoul',
  'Asia/Yakutsk' = 'Asia/Yakutsk',
  'Australia/Adelaide' = 'Australia/Adelaide',
  'Australia/Darwin' = 'Australia/Darwin',
  'Australia/Brisbane' = 'Australia/Brisbane',
  'Australia/Canberra' = 'Australia/Canberra',
  'Australia/Hobart' = 'Australia/Hobart',
  'Pacific/Guam' = 'Pacific/Guam',
  'Asia/Vladivostok' = 'Asia/Vladivostok',
  'Asia/Magadan' = 'Asia/Magadan',
  'Pacific/Auckland' = 'Pacific/Auckland',
  'Pacific/Fiji' = 'Pacific/Fiji',
  'Pacific/Tongatapu' = 'Pacific/Tongatapu',
}

export interface FirebaseMeeting {
  minutesFromWeekStart: number; // The week starts on monday, 00:00
}

export interface FirebaseFileInfo {
  filename: string;
  url: string;
}
